import { type FC } from "react";

import { Flex } from "@mantine/core";
import { Control, Spinner } from "@snapchat/snap-design-system";

import { detailsControl } from "../../../shared/styles";
import { useLensCategoryList } from "../../hooks";

import { SpinnerContainer } from "./LensCategories.styles";

interface LensCategories {
    primaryCategoryId?: string;
    secondaryCategoryId?: string;
}

export const LensCategories: FC<LensCategories> = ({ primaryCategoryId, secondaryCategoryId }) => {
    const { loading: lensCategoryListLoading, categoryMap } = useLensCategoryList();

    if (lensCategoryListLoading) {
        return (
            <SpinnerContainer alignItems="center" justifyContent="center">
                <Spinner />
            </SpinnerContainer>
        );
    }

    return (
        <Flex justify="space-between" gap="md" wrap="wrap">
            <Control
                label="Primary Category"
                tooltip="Categories help users find Lenses that fit their needs. If you have any issues with the assigned category, please reach out to Lens Studio support at lensstudio-support@snapchat.com"
                className={detailsControl}
            >
                {primaryCategoryId ? categoryMap[primaryCategoryId]?.displayName ?? "-" : "-"}
            </Control>
            <Control
                label="Secondary Category"
                tooltip="Secondary categories describe an additional function or use case of your Lens."
                className={detailsControl}
            >
                {secondaryCategoryId ? categoryMap[secondaryCategoryId]?.displayName ?? "-" : "-"}
            </Control>
        </Flex>
    );
};
